import React from 'react';
import { Activity, ShieldCheck, Zap, Baby } from 'lucide-react';
import './ProceduresSection.css';

const ProceduresSection = () => {
  const cards = [
    { icon: <Activity />, title: "Günübirlik İşlemler", text: "Sünnet, kasık fıtığı, göbek fıtığı ve su fıtığı (hidrosel)." },
    { icon: <ShieldCheck />, title: "Ürolojik Müdahaleler", text: "İnmemiş testis, hipospadias (peygamber sünneti) ve vezikoüreteral reflü." },
    { icon: <Zap />, title: "Acil Cerrahiler", text: "Apandisit, invajinasyon (bağırsak düğümlenmesi) ve yabancı cisim yutma/kaçma." },
    { icon: <Baby />, title: "Yenidoğan Anomalileri", text: "Yemek borusu (özofagus atrezisi) ve makat (anorektal malformasyon) kapalılığı." }
  ];

  return (
    <section className="procedures-section section-padding">
      <div className="container">
        <div className="section-title">
          <h2>En Sık Yapılan Cerrahi Müdahaleler</h2>
          <div className="title-line"></div>
        </div>
        
        <div className="slider-container">
          <div className="slider-track">
            {/* Kartları iki kez render ediyoruz ki boşluk kalmasın */}
            {[...cards, ...cards].map((card, index) => (
              <div className="proc-card" key={index}>
                <div className="p-icon-box">{card.icon}</div>
                <h4>{card.title}</h4>
                <p>{card.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProceduresSection;